import { Routes } from '@angular/router';
import { bodySizeRoutes } from '@core/components/telediagnosis/body-size/body-size.routes';
import { ecgRoutes } from '@core/components/telediagnosis/ecg/ecg.routes';
import { faceRoutes } from '@core/components/telediagnosis/face/face.routes';
import { gaitRoutes } from '@core/components/telediagnosis/gait/gait.routes';
import { infraredRoutes } from '@core/components/telediagnosis/infrared/infrared.routes';
import { motionSensorRoutes } from '@core/components/telediagnosis/motion-sensor/motion-sensor.routes';
import { oscRoutes } from '@core/components/telediagnosis/osc/osc.routes';
import { postureRoutes } from '@core/components/telediagnosis/posture/posture.routes';
import { pulsogramRoutes } from '@core/components/telediagnosis/pulsogram/pulsogram.routes';
import { pupilsRoutes } from '@core/components/telediagnosis/pupils/pupils.routes';
import { ClinicNavigationEnum } from '@core/enums/navigation.enum';
import { VideoconsultationRoutes } from '../../../../core/components/telediagnosis/videoconsultation/videoconsultation.routes';
import { MeasurementDashboardComponent } from './measurement-dashboard/measurement-dashboard.component';
import { MeasurementListComponent } from './measurement-list/measurement-list.component';
import { ClinicTelediagnosisComponent } from './telediagnosis.component';
import { weightRoutes } from '@core/components/telediagnosis/weight/weight.routes';

export const telediagnosisRoutes: Routes = [
  {
    path: ClinicNavigationEnum.telediagnosis,
    component: ClinicTelediagnosisComponent,
    children: [
      { path: '', redirectTo: ClinicNavigationEnum.list, pathMatch: 'full' },
      { path: ClinicNavigationEnum.list, component: MeasurementListComponent },
      {
        path: ':patientId',
        component: MeasurementDashboardComponent,
        children: [
          { path: '', redirectTo: ClinicNavigationEnum.os, pathMatch: 'full' },
          {
            path: ClinicNavigationEnum.os,
            loadChildren: () => import('@core/components/telediagnosis/osc/osc.routes').then(() => oscRoutes),
          },
          {
            path: ClinicNavigationEnum.ecg,
            loadChildren: () => import('@core/components/telediagnosis/ecg/ecg.routes').then(() => ecgRoutes),
          },
          {
            path: ClinicNavigationEnum.posture,
            loadChildren: () =>
              import('@core/components/telediagnosis/posture/posture.routes').then(() => postureRoutes),
          },
          {
            path: ClinicNavigationEnum.gait,
            loadChildren: () => import('@core/components/telediagnosis/gait/gait.routes').then(() => gaitRoutes),
          },
          {
            path: ClinicNavigationEnum.body_size,
            loadChildren: () =>
              import('@core/components/telediagnosis/body-size/body-size.routes').then(() => bodySizeRoutes),
          },
          {
            path: ClinicNavigationEnum.motion_sensor,
            loadChildren: () =>
              import('@core/components/telediagnosis/motion-sensor/motion-sensor.routes').then(
                () => motionSensorRoutes,
              ),
          },
          {
            path: ClinicNavigationEnum.face,
            loadChildren: () => import('@core/components/telediagnosis/face/face.routes').then(() => faceRoutes),
          },
          {
            path: ClinicNavigationEnum.pupils,
            loadChildren: () => import('@core/components/telediagnosis/pupils/pupils.routes').then(() => pupilsRoutes),
          },
          {
            path: ClinicNavigationEnum.infrared,
            loadChildren: () =>
              import('@core/components/telediagnosis/infrared/infrared.routes').then(() => infraredRoutes),
          },
          {
            path: ClinicNavigationEnum.pulsogram,
            loadChildren: () =>
              import('@core/components/telediagnosis/pulsogram/pulsogram.routes').then(() => pulsogramRoutes),
          },
          {
            path: ClinicNavigationEnum.weight,
            loadChildren: () => import('@core/components/telediagnosis/weight/weight.routes').then(() => weightRoutes),
          },
        ],
      },
      {
        path: ClinicNavigationEnum.videoconsultation + '/:patientId',
        loadChildren: () =>
          import('../../../../core/components/telediagnosis/videoconsultation/videoconsultation.routes').then(
            () => VideoconsultationRoutes,
          ),
      },
    ],
  },
];
